module.exports = __webpack_public_path__ + "media/images/home/cover-desktop-44a5732ac36c0f308e1ef1132ae2da3c.jpg";